import {
  AlertBox,
  CheckboxGroup,
  RadioGroup,
} from "@life-line-lab/components-react";
import { Col, Row } from "antd";
import { ParcelTypeEnums } from "Data/order";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

interface CustomerProfileParcelProps {
  input: any;
  error: any;
  handleSelectChange: (value: string | string[], name: string) => void;
}

const CustomerProfileParcelTypes: FC<CustomerProfileParcelProps> = (props) => {
  const { input, error, handleSelectChange } = props || {};

  const { t } = useTranslation();

  const options = [
    {
      label: t(`option.${ParcelTypeEnums.INDIVIDUAL}` as any),
      value: ParcelTypeEnums.INDIVIDUAL,
    },
    {
      label: t(`option.${ParcelTypeEnums.SPLIT}` as any),
      value: ParcelTypeEnums.SPLIT,
    },
    {
      label: t(`option.${ParcelTypeEnums.BULK}` as any),
      value: ParcelTypeEnums.BULK,
    },
  ];

  const radioOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];

  return (
    <div className="customer-profile-parcel-types customer-profile-shared">
      <div className="cppt-inner">
        <Row gutter={[32, 0]}>
          <Col>
            <CheckboxGroup
              label={t("label.parcelType")}
              direction="horizontal"
              options={options}
              value={input?.parcelTypes}
              onChange={(value) => handleSelectChange(value, "parcelTypes")}
            />
            <AlertBox text={error?.parcelTypes} />
          </Col>
          <Col>
            <RadioGroup
              options={radioOptions as any}
              direction="horizontal"
              value={input?.allowPickupAll}
              label={t("label.allowPickupAll")}
              name="allowPickupAll"
              input={input?.allowPickupAll}
              onChange={(event) => handleSelectChange(event?.target.value, "allowPickupAll")}
            />
            <AlertBox text={error?.parcelTypes} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CustomerProfileParcelTypes;
